import type { HexString } from "@/types/general.types";
import { create } from "zustand";

interface StyleControls {
  isModelLoaded: boolean;
  setIsModelLoaded: (val: boolean) => void;
  introAnimationCompleted: boolean;
  setIntroAnimationCompleted: (val: boolean) => void;
  isMouseOver: boolean;
  setIsMouseOver: (val: boolean) => void;
  isContainerExpanded: boolean;
  setIsContainerExpanded: (val: boolean) => void;
  isNavbarScrolled: boolean;
  setIsNavbarScrolled: (val: boolean) => void;
  isSocialAccountBeingCreated: boolean;
  setIsSocialAccountBeingCreated: (val: boolean) => void;
  isPendingTransaction: boolean;
  setIsPendingTransaction: (val: boolean) => void;
  pendingTxns: HexString[];
  addPendingTxn: (txn: HexString) => void;
  flushPendingTxn: (txn: HexString) => void;
  isSigningPending: boolean;
  setIsSigningPending: (val: boolean) => void;
}

export const useUIStore = create<StyleControls>((set) => ({
  isPendingTransaction: false,
  setIsPendingTransaction: (val: boolean) => set({ isPendingTransaction: val }),
  isModelLoaded: false,
  setIsModelLoaded: (val: boolean) => set({ isModelLoaded: val }),
  introAnimationCompleted: false,
  setIntroAnimationCompleted: (val) => set({ introAnimationCompleted: val }),
  isMouseOver: false,
  setIsMouseOver: (val: boolean) => set({ isMouseOver: val }),
  isContainerExpanded: false,
  setIsContainerExpanded: (val) => set({ isContainerExpanded: val }),
  isNavbarScrolled: false,
  setIsNavbarScrolled: (val) => set({ isNavbarScrolled: val }),
  isSocialAccountBeingCreated: false,
  setIsSocialAccountBeingCreated: (val) =>
    set({ isSocialAccountBeingCreated: val }),
  // Transaction UI state management
  pendingTxns: [],
  addPendingTxn: (txn) =>
    set((prev) => ({ pendingTxns: [...prev.pendingTxns, txn] })),
  flushPendingTxn: (txn) =>
    set((prev) => ({ pendingTxns: prev.pendingTxns.filter((t) => t !== txn) })),
  setPendingTxns: (val: HexString[]) => set({ pendingTxns: val }),
  isSigningPending: false,
  setIsSigningPending: (val: boolean) => set({ isSigningPending: val }),
}));
